import React, { useEffect, useState } from 'react';
import { Select } from 'antd';
import { menuItemTransport } from 'entities/MenuItem/MenuItem.transport';
import { IMenuItemModel } from 'entities/MenuItem/MenuItem.models';
import { ECommonEntityStatus } from 'entities/Bitecoin/Bitecoin.models';

interface IComponentProps {
  role: 'drink' | 'side';
  // Restricts drink options to the combo's drink temperature (ignored for role=side).
  drinkTemperature?: 'hot' | 'cold';
  value?: string | null;
  onChange?: (value: string | null) => void;
  disabled?: boolean;
  placeholder?: string;
}

// Loads the franchisor's global Meal Builder drink/side menu items as options for the combo
// "Default drink"/"Default side" selects. No "Any" entry — leaving it empty hides the combo.
export const MealBuilderItemSelect: React.FC<IComponentProps> = ({
  role,
  drinkTemperature,
  value,
  onChange,
  disabled,
  placeholder,
}) => {
  const [options, setOptions] = useState<IMenuItemModel[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    menuItemTransport
      .getCollection({
        mealBuilderRole: role,
        ...(role === 'drink' && drinkTemperature ? { drinkTemperature } : {}),
        statuses: [ECommonEntityStatus.Active],
        limit: 100,
      })
      .then((collection) => {
        if (!cancelled) {
          setOptions(collection.data ?? []);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });

    return () => {
      cancelled = true;
    };
  }, [role, drinkTemperature]);

  return (
    <Select
      className="width-full"
      placeholder={placeholder}
      allowClear
      showSearch
      optionFilterProp="label"
      loading={loading}
      disabled={disabled}
      value={value ?? undefined}
      onChange={(next) => onChange?.(next ?? null)}
      options={options.map((item) => ({ value: item.id, label: item.name }))}
    />
  );
};
